import { formatUsdCompact } from '../../lib/lighterApi'
import {
  formatPoolAge,
  formatPoolApr,
  formatPoolFee,
  formatPoolSharpe,
  signedClass,
} from '../../data/publicPools'

const BADGE_BASE =
  'inline-flex items-center justify-center rounded-pill border-[0.5px] border-line bg-fill p-1 font-mono text-2xs leading-none tracking-caps uppercase shadow-[inset_0_var(--hl-y)_0_0_var(--hl-top),0px_0px_0px_0.5px_var(--ring-crisp)] light:border-transparent light:shadow-none'

const ROW_CLASS =
  'absolute flex w-full items-center max-mobile:px-1 gap-3 px-3 text-base/md text-ink tabular-nums group cursor-pointer hover:bg-ink/5 hover:[--row-tint:color-mix(in_oklab,var(--color-ink)_5%,transparent)] h-[52px] min-h-[52px]'

export default function PoolRow({ pool, index }) {
  const testId = `row-${index}`
  const aprClass = signedClass(pool.apr)
  const sharpeClass = signedClass(pool.sharpe)

  return (
    <tr
      data-index={index}
      data-testid={testId}
      className={ROW_CLASS}
      style={{ transform: `translateY(${index * 52}px)` }}
    >
      <td
        data-testid={`${testId}-cell-${index}_name`}
        className="flex grow items-center self-stretch min-w-0 tabular-nums text-md text-ink"
        style={{ width: 210 }}
      >
        <div className="flex min-w-0 items-center gap-2">
          <p className="min-w-0 flex-1 truncate">{pool.name}</p>
        </div>
      </td>
      <td
        data-testid={`${testId}-cell-${index}_operator`}
        className="flex grow-0 shrink-0 tabular-nums"
        style={{ width: 168 }}
      >
        <div className="flex min-w-0 items-center gap-1.5">
          {pool.isProtocol ? null : (
            <span className="truncate font-mono text-xs text-dim tabular-nums">
              {pool.operatorLabel}
            </span>
          )}
          <span
            className={
              pool.isProtocol
                ? `${BADGE_BASE} text-link light:bg-badge-accent-bg light:text-badge-accent-ink`
                : `${BADGE_BASE} text-muted light:bg-badge-neutral-bg light:text-badge-neutral-ink`
            }
          >
            {pool.isProtocol ? 'Lighter' : 'Community'}
          </span>
        </div>
      </td>
      <td
        data-testid={`${testId}-cell-${index}_operatorFee`}
        className="flex grow min-w-0 tabular-nums text-sm text-dim"
        style={{ width: 72 }}
      >
        {formatPoolFee(pool.fee)}
      </td>
      <td
        data-testid={`${testId}-cell-${index}_apr`}
        className="flex grow min-w-0 tabular-nums text-sm"
        style={{ width: 88 }}
      >
        <span className={aprClass}>{formatPoolApr(pool.apr)}</span>
      </td>
      <td
        data-testid={`${testId}-cell-${index}_sharpeRatio`}
        className="flex grow min-w-0 tabular-nums text-sm"
        style={{ width: 100 }}
      >
        <span className={sharpeClass}>{formatPoolSharpe(pool.sharpe)}</span>
      </td>
      <td
        data-testid={`${testId}-cell-${index}_tvl`}
        className="flex grow min-w-0 tabular-nums text-sm"
        style={{ width: 116 }}
      >
        <span
          className="cursor-help underline decoration-muted/50 decoration-dotted underline-offset-[3px]"
          data-state="closed"
          title={
            Number.isFinite(pool.tvl)
              ? `$${pool.tvl.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : undefined
          }
        >
          {formatUsdCompact(pool.tvl)}
        </span>
      </td>
      <td
        data-testid={`${testId}-cell-${index}_age`}
        className="flex grow min-w-0 tabular-nums text-sm text-dim"
        style={{ width: 100 }}
      >
        {formatPoolAge(pool.ageDays)}
      </td>
      <td
        data-testid={`${testId}-cell-${index}_yourDeposit`}
        className="flex grow min-w-0 tabular-nums text-sm text-muted"
        style={{ width: 104 }}
      >
        -
      </td>
      <td
        data-testid={`${testId}-cell-${index}_yourEquity`}
        className="flex grow min-w-0 tabular-nums text-sm text-muted"
        style={{ width: 104 }}
      >
        -
      </td>
    </tr>
  )
}
